import React from "react";
import { Link } from "react-router-dom";
import { API_BASE } from "../api";

const pageStyles = {
  shell: {
    minHeight: "100vh",
    background:
      "radial-gradient(circle at top, #041318 0, #020814 45%, #020308 100%)",
    color: "#e5e7eb",
    padding: "1.5rem",
  },
  wrap: {
    maxWidth: 1200,
    margin: "0 auto",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
    marginBottom: "1.5rem",
    flexWrap: "wrap",
  },
  title: {
    margin: 0,
    fontSize: "1.8rem",
    letterSpacing: "0.04em",
  },
  subtitle: {
    margin: "0.35rem 0 0",
    fontSize: "0.92rem",
    color: "#9ca3af",
    maxWidth: 720,
  },
  backLink: {
    fontSize: "0.85rem",
    padding: "0.45rem 0.85rem",
    borderRadius: 999,
    border: "1px solid rgba(148,163,184,0.5)",
    textDecoration: "none",
    color: "#e5e7eb",
  },
  card: {
    borderRadius: 16,
    border: "1px solid rgba(148,163,184,0.35)",
    background: "rgba(15,23,42,0.85)",
    padding: "1rem 1.25rem 1.25rem",
    boxShadow: "0 18px 40px rgba(2, 8, 20, 0.28)",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: "1rem",
    flexWrap: "wrap",
  },
  cardTitle: {
    margin: 0,
    fontSize: "1.1rem",
  },
  cardText: {
    margin: "0.25rem 0 0",
    fontSize: "0.85rem",
    color: "#9ca3af",
  },
  openLink: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0.55rem 0.95rem",
    borderRadius: 999,
    border: "1px solid rgba(148,163,184,0.5)",
    background: "rgba(2,8,20,0.7)",
    color: "#e5e7eb",
    textDecoration: "none",
    fontSize: "0.85rem",
  },
  frameWrap: {
    borderRadius: 12,
    overflow: "hidden",
    border: "1px solid rgba(30,41,59,0.9)",
    background: "#f8fafc",
    boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.06)",
  },
  frame: {
    width: "100%",
    minHeight: "75vh",
    height: "calc(100vh - 240px)",
    border: 0,
    background: "#ffffff",
  },
};

export default function AdminTipsterManagement() {
  const tipsterManagementUrl = `${API_BASE}/admin/tipsters`;

  return (
    <div style={pageStyles.shell}>
      <div style={pageStyles.wrap}>
        <header style={pageStyles.header}>
          <div>
            <h1 style={pageStyles.title}>Tipster Management</h1>
            <p style={pageStyles.subtitle}>
              Manage live tipsters from the existing backend admin interface.
            </p>
          </div>

          <Link to="/admin" style={pageStyles.backLink}>
            ← Back to admin
          </Link>
        </header>

        <section style={pageStyles.card}>
          <div style={pageStyles.cardHeader}>
            <div>
              <h2 style={pageStyles.cardTitle}>Manage tipsters</h2>
              <p style={pageStyles.cardText}>
                The embedded admin page supports listing and deleting tipsters.
              </p>
            </div>

            <a
              href={tipsterManagementUrl}
              target="_blank"
              rel="noreferrer"
              style={pageStyles.openLink}
            >
              Open in New Tab
            </a>
          </div>

          <div style={pageStyles.frameWrap}>
            <iframe
              title="Tipster Management"
              src={tipsterManagementUrl}
              style={pageStyles.frame}
            />
          </div>
        </section>
      </div>
    </div>
  );
}
